import React from 'react';

import Button from '@mui/material/Button';
import styled, { CSSObject } from 'styled-components';

import ArrowIcon from '../assets/icon-back18x12.svg';

interface Props {
  children: string | React.ReactElement;
  onClick: (e?: any) => void;
  design: 'white' | 'black' | 'gray' | 'palegray' | 'filled' | 'outline' | 'active' | 'inactive';
  icon?: 'back' | 'forward';
  style?: CSSObject;
  disabled?: boolean;
  disableRipple?: boolean;
  radius?: string;
  $isFormikDirty?: boolean;
  $isFormikError?: boolean;
  $fontColor?: string;
}

const RoundBtn = React.forwardRef<HTMLButtonElement, Props>(
  ({ children, onClick, design, icon, style, ...rest }, ref) => {
    return (
      <StyledBtn type="button" onClick={onClick} design={design} style={style} ref={ref} {...rest}>
        {icon === 'back' && (
          <span className="arrow">
            <ArrowIcon />
          </span>
        )}
        {children}
        {icon === 'forward' && (
          <span className="arrow forward">
            <ArrowIcon />
          </span>
        )}
      </StyledBtn>
    );
  }
);

export default RoundBtn;

const StyledBtn = styled(Button)<{
  $fontColor?: string;
  radius?: string;
  design?: 'white' | 'black' | 'gray' | 'palegray' | 'filled' | 'outline' | 'active' | 'inactive';
  style?: any;
  $isFormikDirty?: boolean;
  $isFormikError?: boolean;
}>`
  min-width: 80px !important;
  height: 32px;
  vertical-align: baseline;
  border-radius: ${(props) => props.radius ?? '15px'} !important;
  color: ${(props) => props.theme.color.static.black};
  font-family: Poppins, sans-serif !important;
  text-transform: initial !important;
  font-size: 16px !important;
  span {
    // 버튼 내부 Font 중앙 정렬 용
    line-height: 1;
  }

  & .arrow {
    height: 12px;
  }
  & .forward {
    margin-left: 4px;
    line-height: 1;
    transform: rotate(180deg);
    use {
      fill: ${({ theme, design }) =>
        design === 'filled' || design === 'inactive' ? theme.color.static.white : theme.color.static.primary};
    }
  }

  ${(props) =>
    props?.design === 'white' &&
    `
		color: ${props.theme.color.static.white} !important;
		border: ${props.theme.color.static.white} 1px solid !important;
	`}
  ${(props) =>
    props?.design === 'black' &&
    `
		color: ${props.theme.color.text.TXT_4} !important;
		border: ${props.theme.color.text.TXT_4} 1px solid !important;
	`}
  ${(props) =>
    props?.design === 'gray' &&
    `
		color: #909090 !important;
   	border: ${props.theme.palette.neutral[30]} 1px solid;
    font-weight: normal !important;
	`}
    ${(props) =>
    props?.design === 'palegray' &&
    `
		color: #909090 !important;
   	border: #f1f1f4 1px solid !important;
    font-weight: normal !important;
	`}
  ${(props) =>
    props?.design === 'outline' &&
    `
		color: ${props.theme.color.static.primary} !important;
		border: ${props.theme.color.static.primary} 1px solid !important;
  `}
  ${(props) =>
    props?.design === 'filled' &&
    `
		color: #fff !important;
    background-color: ${props.theme.color.static.primary} !important;
    font-weight: 600 !important;
  `}

  ${(props) =>
    props?.design === 'active' &&
    `
    border: ${props.theme.color.static.primary} 1px solid !important;
    color: ${
      !props.$isFormikError && props.$isFormikDirty ? props.theme.color.static.white : props.theme.color.static.primary
    } !important;
    background-color: ${
      !props.$isFormikError && props.$isFormikDirty ? props.theme.color.static.primary : props.theme.color.static.white
    } !important;
    font-weight: ${!props.$isFormikError && props.$isFormikDirty ? '600' : 'normal'} !important;
  `}

  ${(props) =>
    props?.design === 'inactive' &&
    `
		color: ${props.theme.color.static.white} !important;
    background-color: ${props.theme.palette.neutral[30]} !important;
    font-weight: 600 !important;
  `}

  ${(props) =>
    props.disabled &&
    `cursor: not-allowed !important;
     pointer-events: initial !important; 
     background-color: ${props.theme.palette.neutral[20]} !important;
  `}
  color: ${(props) => props?.$fontColor} !important;

  ${(props) => ({ ...props.style })}
`;
